(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'babel-runtime/helpers/taggedTemplateLiteralLoose', 'react', 'react-emotion', '../../svg'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('babel-runtime/helpers/taggedTemplateLiteralLoose'), require('react'), require('react-emotion'), require('../../svg'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.taggedTemplateLiteralLoose, global.react, global.reactEmotion, global.svg);
    global.UpperCornerBadge = mod.exports;
  }
})(this, function (exports, _taggedTemplateLiteralLoose2, _react, _reactEmotion, _svg) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _taggedTemplateLiteralLoose3 = _interopRequireDefault(_taggedTemplateLiteralLoose2);

  var _react2 = _interopRequireDefault(_react);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  var _templateObject = (0, _taggedTemplateLiteralLoose3.default)(['\n      display: inline-block;\n      position: absolute;\n      overflow: hidden;\n      border-top-', '-radius: 6px;\n      z-index: ', ';\n      top: 0;\n      ', ': 0\n    '], ['\n      display: inline-block;\n      position: absolute;\n      overflow: hidden;\n      border-top-', '-radius: 6px;\n      z-index: ', ';\n      top: 0;\n      ', ': 0\n    ']),
      _templateObject2 = (0, _taggedTemplateLiteralLoose3.default)(['\n    width: 0;\n    height: 0;\n    border-top: ', 'px solid ', ';\n    border-', ': ', 'px solid transparent;\n    '], ['\n    width: 0;\n    height: 0;\n    border-top: ', 'px solid ', ';\n    border-', ': ', 'px solid transparent;\n    ']),
      _templateObject3 = (0, _taggedTemplateLiteralLoose3.default)(['\n            z-index: 99999;\n            font-size: 1.3em;\n            position: absolute;\n            top: 0.375rem;\n            ', ': 6px;\n          '], ['\n            z-index: 99999;\n            font-size: 1.3em;\n            position: absolute;\n            top: 0.375rem;\n            ', ': 6px;\n          ']);

  var UpperCornerBadge = function UpperCornerBadge(_ref) {
    var color = _ref.color,
        className = _ref.className,
        badgeSize = _ref.badgeSize,
        iconColor = _ref.iconColor,
        iconSize = _ref.iconSize,
        position = _ref.position,
        zindex = _ref.zindex;
    return _react2.default.createElement(
      'div',
      {
        className: (0, _reactEmotion.cx)((0, _reactEmotion.css)(_templateObject, position === 'left' ? 'left' : 'right', zindex, position === 'left' ? 'left' : 'right'), className)
      },
      _react2.default.createElement(
        'div',
        {
          className: (0, _reactEmotion.cx)((0, _reactEmotion.css)(_templateObject2, badgeSize, color, position === 'left' ? 'right' : 'left', badgeSize), className)
        },
        _react2.default.createElement(
          'span',
          {
            className: (0, _reactEmotion.cx)((0, _reactEmotion.css)(_templateObject3, position === 'left' ? 'left' : 'right'), className)
          },
          _react2.default.createElement(_svg.ApproverFlyer, { size: iconSize, color: iconColor })
        )
      )
    );
  };

  exports.default = UpperCornerBadge;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/elements/cornerBadge/UpperCornerBadge.js
// module id = 1858
// module chunks = 1